export const accordionItems = [
  {
    title: "Quem é a Primatio Cyber Security?",
    description:
      "A Primatio é uma empresa de tecnologia especializada no desenvolvimento de soluções digitais inovadoras com foco em Saúde e Cyber Segurança. Com forte atuação em aplicativos mobile, segurança da informação, inteligência artificial aplicada e integrações com sistemas legados, a Primatio combina expertise técnica com uma visão centrada no impacto social e na experiência do usuário.",
  },
  {
    title: "O que é autenticação por prova de vida?",
    description: "Autenticação por prova de vida (ou liveness detection) é uma técnica usada para garantir que a pessoa tentando acessar um sistema está viva e presente no momento da autenticação, e não é uma fraude (como uma foto, vídeo, máscara ou deepfake).",
  },
  {
    title: "Por que eliminar senhas?",
    description: "Eliminar senhas é uma tendência crescente porque as senhas são um dos elos mais fracos da segurança digital.",
  },
  {
    title: "Posso contratar apenas um dos serviços?",
    description: "Sim, você pode contratar apenas um dos serviços da Primatio, conforme sua necessidade. A Primatio oferece soluções modulares e personalizáveis, como: 🔒 Cofre de Senhas com prova de vida\n🧠 Inteligência Artificial aplicada à Cyber Segurança\n📲 Desenvolvimento de apps mobile ou web sob demanda",
  },
  {
    title: "A Primatio atende empresas de todos os tamanhos?",
    description: "Sim, a Primatio atende empresas de todos os tamanhos, desde startups até grandes corporações. Nossa equipe de especialistas está pronta para ajudar você a implementar soluções de segurança e tecnologia que atendam às necessidades específicas de sua empresa.",
  },
  {
    title: "Como posso contratar os serviços da Primatio?",
    description: "Para contratar os serviços da Primatio, você pode entrar em contato conosco através do email felipe@primat.io. Nossa equipe de especialistas está pronta para ajudar você a implementar soluções de segurança e tecnologia que atendam às necessidades específicas de sua empresa.",
  },
];
